export default __webpack_public_path__ + "static/media/SWT2030.34I-44030_-26312_0.9aa5b48e.jpg";